// One person = one Intercom contact and one FullStory record across Classic,
// NextGen and the Acceleration Point platform (#194). The API issues
// `personId` once IDENTITY_EMAIL_HMAC_KEY is set and signs the Intercom
// identity itself (#23, `intercomUserHash`); until the key is set Classic keeps
// today's hashid `userId`. The browser never computes an id or a signature.

export const trackingUserId = userDetails => userDetails?.personId ?? userDetails?.userId;

export const intercomBootSettings = ({ userDetails, currentModule, currentProject, now }) => ({
  api_base: 'https://api-iam.intercom.io',
  app_id: 'y588ttna',
  email: userDetails?.email,
  user_id: trackingUserId(userDetails),
  name: userDetails?.name,
  userClientName: userDetails.clientName,
  userClientId: userDetails.clientId,
  created_at: now,
  ...(userDetails?.intercomUserHash ? { user_hash: userDetails.intercomUserHash } : {}),
  moduleName: currentModule?.name,
  currentProjectId: currentModule?.currentProject,
  projectClientName: currentProject?.projectClientName,
  projectDisplayName: currentProject?.projectDisplayName,
  company: {
    company_id: userDetails.clientId,
    name: userDetails.clientName,
  },
  hide_default_launcher: false,
});

export const fullStoryIdentity = ({ userDetails, currentModule, currentProject }) => ({
  uid: trackingUserId(userDetails),
  properties: {
    displayName: userDetails.name,
    email: userDetails.email,
    user_id: trackingUserId(userDetails),
    userClientName: userDetails.clientName,
    userClientId: userDetails.clientId,
    moduleName: currentModule?.name,
    currentProjectId: currentModule?.currentProject,
    projectClientName: currentProject?.projectClientName,
    projectDisplayName: currentProject?.projectDisplayName,
    company_id: userDetails.clientId,
    name: userDetails.clientName,
  },
});
